import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import classNames from 'classnames';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';

import { FormattedMessageWrappedInSpan } from '../../misc';

import GenerateVideoMutation from '../../../mutations/GenerateVideoMutation';
import environment from '../../../environment';

const ENTER_KEY = 'Enter';

const AccountVideoDownloadForm = (props) => {

  const {
    intl,
    eventSgId
  } = props;

  const [failed, setFailed] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [showError, setShowError] = useState(false);
  const [startnumber, setStartnumber] = useState('');

  const handleStartnumberInputChanged = event => {
    setShowError(false);
    setStartnumber(event.target.value);
  };

  const handleKeyPress = event => {
    if (event.key === ENTER_KEY && !isPending) {
      submitForm();
    }
  };

  const submitForm = () => {
    if (!startnumber) {
      setShowError(true);
      return;
    }

    generateVideoDownloadLink();
  };

  const getErrorMessage = () => {
    if (showError) {
      return intl.formatMessage(translations.inputErrorText);
    }
    if (failed) {
      return intl.formatMessage(translations.outcomeErrorText);
    }

    return false;
  };

  const not_ready = () => {
    return (!startnumber || isPending);
  }

  const download = (url) => {
    window.location.href = url;
  };

  const generateVideoDownloadLink = () => {
    setIsPending(true);

    GenerateVideoMutation.commit(
      environment,
      eventSgId,
      startnumber,
      (error, url) => {
        if (!error) {
          setFailed(false);
          download(url);
        } else {
          setFailed(true);
        }
        setIsPending(false);
      }
    );
  }

  return (
    <div className="notification-container">
      <DialogContent>
        <div className="notification-body">
          <FormGroup>
            <TextField
              autoComplete="off"
              autoFocus={startnumber === ''}
              className="notification-input"
              error={getErrorMessage()}
              id="startnumber"
              helperText={getErrorMessage()}
              label={intl.formatMessage(translations.startnumberTextFieldLabel)}
              onChange={handleStartnumberInputChanged}
              onKeyPress={handleKeyPress}
              placeholder={intl.formatMessage(translations.startnumberTextFieldPlaceholder)}
              value={startnumber}
            />
          </FormGroup>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="notification-action with-spinner">
          <button
            className={classNames('accept', { disabled: not_ready() })}
            disabled={not_ready()}
            onClick={submitForm}
          >
            <FormattedMessageWrappedInSpan
              id="accountVideoDownloadForm.acceptButton"
              defaultMessage="Download"
            />
            {isPending && (
              <div className="download-dropdown-expand-icon-container">
                <CircularProgress
                  classes={{ circle: 'circular-progress-circle-copy-color-medium' }}
                  size={20}
                  thickness={3}
                />
              </div>
            )}
          </button>
        </div>
      </DialogActions>
    </div>
  );
}

const translations = defineMessages({
  startnumberTextFieldLabel: {
    id: 'accountVideoDownloadForm.startnumberTextFieldLabel',
    defaultMessage: 'Start Number',
  },
  startnumberTextFieldPlaceholder: {
    id: 'accountVideoDownloadForm.startnumberTextFieldPlaceholder',
    defaultMessage: 'Enter one start number',
  },
  inputErrorText: {
    id: 'accountVideoDownloadForm.inputErrorText',
    defaultMessage: 'This field is required',
  },
  outcomeErrorText: {
    id: 'accountVideoDownloadForm.outcomeErrorText',
    defaultMessage: 'Could not download. Have you given a correct start number?',
  },
});

AccountVideoDownloadForm.propTypes = {
  intl: PropTypes.object,
  eventSgId: PropTypes.number
};

export default injectIntl(AccountVideoDownloadForm);
export { AccountVideoDownloadForm };
